import React, { useState, useEffect } from 'react';

interface OtpTimerProps {
	expiryTime: number; // Unix timestamp representing the expiry time
	handleResend: (data: any) => void;
}

const OtpTimer: React.FC<OtpTimerProps> = ({ expiryTime, handleResend }) => {
	const calculateTimeLeft = () => {
		const currentTime = new Date().getTime();
		const timeDifference = expiryTime - currentTime;

		if (timeDifference < 0) {
			return { minutes: 0, seconds: 0 };
		}

		const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
		const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
		return { minutes, seconds };
	};

	const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

	useEffect(() => {
		const timer = setInterval(() => {
			setTimeLeft(calculateTimeLeft());
		}, 1000);

		return () => clearInterval(timer);
	}, [expiryTime]);

	const formatTime = (time: { minutes: number; seconds: number }) => {
		return `${time.minutes.toString().padStart(2, '0')}:${time.seconds
			.toString()
			.padStart(2, '0')}`;
	};

	return (
		<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
			{timeLeft.minutes === 0 && timeLeft.seconds === 0 ? (
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					Didn’t get the code?
					<span style={{ cursor: 'pointer' }} onClick={handleResend} className="default-text">
						Resend
					</span>
				</div>
			) : (
				<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
					<p>Time Remaining: {formatTime(timeLeft)}</p>
					<span style={{ cursor: 'pointer' }} className="gray-light">
						Resend
					</span>
				</div>
			)}
		</div>
	);
};

export default OtpTimer;
